import { Input } from "antd";
import type { ChangeEvent } from "react";
import { Settings } from "@version2/domain-package";

type EmailFieldProps = {
	settings: Settings;
	onSettingsChange: (settings: Settings) => void;
};

const EmailField = ({ settings, onSettingsChange }: EmailFieldProps) => {
	return (
		<Input
			value={settings?.value}
			onChange={(e: ChangeEvent<HTMLInputElement>) =>
				onSettingsChange(settings.copyWith({ editedValue: e.target.value }))
			}
		/>
	);
};

export default EmailField;
